import { render, staticRenderFns } from "./history-record-board.vue?vue&type=template&id=b7628ed6"
import script from "./history-record-board.vue?vue&type=script&lang=js"
export * from "./history-record-board.vue?vue&type=script&lang=js"
import style0 from "./history-record-board.vue?vue&type=style&index=0&id=b7628ed6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports